import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { EndorsementCallRegister } from "../interfaces/endorsement-call.interface";

@Injectable()
export class EndorsementCallsService {
  constructor(private http: HttpClientService) {}

  public registerEndorsementCall(params: EndorsementCallRegister): Observable<any> {
    return this.http
      .post(`/api/endorsement_calls`, params)
      .pipe(tap((_) => console.log("EndorsementCallsService.registerEndorsementCall: Ok.")));
  }

  public getEndorsementCalls(application_id: string): Observable<any> {
    return this.http
      .get(`/api/applications/${application_id}/endorsement_calls`)
      .pipe(tap((_) => console.log("EndorsementCallsService.getEndorsementCalls: Ok.")));
  }
}
